import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=45b1fade&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=45b1fade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1fade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b1fade')) {
      api.createRecord('45b1fade', component.options)
    } else {
      api.reload('45b1fade', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=45b1fade&scoped=true&", function () {
      api.rerender('45b1fade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N1MH9vbiKSII/JS/teamMember.vue"
export default component.exports